<script>
import TextAccordion from "@js/components/Sections/TextBlocks/TextAccordion.vue";

export default {
    name: "ProductDeliveryInfo",
    components: {TextAccordion}
}
</script>

<template>
    <div class="p-5 border border-gray-200 shadow-sm bg-[#d1ecf1] rounded-lg">
        <div class="text-base font-bold text-black mb-5">
            Доставка
        </div>
        <TextAccordion :minHeight="75">
            <ul class="max-w-md space-y-4 list-disc list-outside text-white text-base md:text-xl ms-6">
                <li class="text-xs text-black font-medium">
                    ООО «ФУЛЛ СТРОЙ» организует доставку строительных материалов на объекты заказчиков. Привозим ЖБИ,
                    бетонные смеси, пиломатериалы, тротуарную плитку, нерудные материалы и строительные конструкции.
                </li>
                <li class="text-xs text-black font-medium">
                    Перед отгрузкой менеджер уточняет объем заказа, адрес, удобное время приемки и особенности подъезда
                    к объекту. Это помогает заранее подобрать транспорт и избежать лишних задержек.
                </li>
                <li class="text-xs text-black font-medium">
                    Для разных категорий материалов подбираем подходящий транспорт - от машин под сыпучие материалы до
                    грузового транспорта для ЖБИ, пиломатериалов и крупногабаритных конструкций.
                </li>
                <li class="text-xs text-black font-medium">
                    Доставка выполняется по Москве и Московской области. Сроки и стоимость зависят от объема заказа,
                    типа материалов, адреса объекта и условий разгрузки.
                </li>
            </ul>
        </TextAccordion>
    </div>
</template>

<style scoped lang="scss">

</style>
